type SharedEntry = { promise: Promise<unknown>; expiresAt: number }

const sharedRequests = new Map<string, SharedEntry>()

/**
 * Collapses identical browser requests: callers with the same key share one in-flight promise, and
 * a resolved result is reused for `ttlMs`. Server renders bypass it, as module state there is
 * shared across shoppers.
 */
export const shareRequest = <T>(key: string, request: () => Promise<T>, ttlMs = 0): Promise<T> => {
  if (import.meta.server) return request()

  const existing = sharedRequests.get(key)
  if (existing && (existing.expiresAt === Infinity || existing.expiresAt > Date.now())) {
    // SAFETY: entries are only stored under a key by a `request` returning T.
    return existing.promise as Promise<T>
  }

  const promise = request()
  const entry: SharedEntry = { promise, expiresAt: Infinity }
  sharedRequests.set(key, entry)
  const forget = () => {
    if (sharedRequests.get(key) === entry) sharedRequests.delete(key)
  }
  promise.then(() => {
    if (ttlMs > 0) entry.expiresAt = Date.now() + ttlMs
    else forget()
  }, forget)
  return promise
}
